import { pointMeasurementConfig } from './point';
import { polylineMeasurementConfig } from './polyline';
import { lineMeasurementConfig } from './line';
import { angleMeasurementConfig } from './angle';
import { alignmentMeasurementConfig } from './alignment';
import type { MeasurementType } from '@trimble/web3d-providers';
import { volumeMeasurementConfig } from '@features/measurements/volumetric-measurements-ui';
import { areaMeasurementConfig } from './area';

export type { MeasurementType };

export const measurementRegistry = {
  point: pointMeasurementConfig,
  polyline: polylineMeasurementConfig,
  line: lineMeasurementConfig,
  angle: angleMeasurementConfig,
  alignment: alignmentMeasurementConfig,
  volume: volumeMeasurementConfig,
  area: areaMeasurementConfig,
} as const;

export type SupportedMeasurementType = keyof typeof measurementRegistry;

export type MeasurementConfig =
  (typeof measurementRegistry)[SupportedMeasurementType];

export function isSupportedMeasurementType(
  type: MeasurementType
): type is SupportedMeasurementType {
  return type in measurementRegistry;
}

export function getMeasurementConfig(
  type: SupportedMeasurementType
): MeasurementConfig {
  return measurementRegistry[type];
}
